
import Icon from 'vux/src/components/icon/index.vue'

import { getaddlog } from '@/api/hgfw'
export default {
components: {
Icon
},
data () {
return {
}
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
this.addLog()
},
methods: {

addLog () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120120
})
}
}
}
